import { Analytics } from "@/components/analytics/Analytics";
import { JsonLd, organizationLd, webSiteLd } from "@/lib/seo";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { EtfFooter } from "./EtfFooter";
import { EtfNav } from "./EtfNav";
import { LeavingSiteModal } from "./LeavingSiteModal";

export function Layout() {
  // Re-apply the persisted theme from localStorage so a user who selected
  // light mode lands back in light mode after a hard reload. Key "corgi-theme"
  // is shared with EtfNav so the nav toggle and layout stay in sync.
  useEffect(() => {
    const saved = localStorage.getItem("corgi-theme");
    if (saved === "light") {
      document.documentElement.setAttribute("data-theme", "light");
    }
  }, []);

  return (
    <div className="etf-site min-h-screen flex flex-col">
      {/* Sitewide structured data — Organization + WebSite are referenced by
          @id from the per-page FinancialProduct / BlogPosting / CollectionPage
          blocks, so the knowledge graph resolves to one publisher entity. */}
      <JsonLd data={[organizationLd(), webSiteLd()]} />
      {/* First-party website analytics — pageviews + classified click capture. */}
      <Analytics />
      {/* Slot for the buffer fund pages' top risk strip — renders ABOVE the
          nav (matches static reference: strip scrolls away, sticky nav
          remains pinned). */}
      <div id="etf-pre-nav-slot" />
      <EtfNav />
      <Outlet />
      <EtfFooter />
      {/* Cross-subdomain interstitial — warns when navigating between the funds
          site and the blog (blog.corgifunds.com). Mounted once here so it
          listens on whichever host serves the SPA. */}
      <LeavingSiteModal />
    </div>
  );
}
